import React from "react";
import CiroCreateableTextInput from "../../../../../shared/CiroCreateableTextInput";
import { IPowersearchFieldValueProps } from "./PowersearchFieldValue";

export const PowersearchStateValueEditor: React.FC<
  IPowersearchFieldValueProps
> = ({ value, handleOnChange, disabled, errorMessage }) => {
  return (
    <CiroCreateableTextInput
      containerWidthClass={"w-full"}
      value={Array.isArray(value) ? value : []}
      placeholder="Texas, Vermont, Ontario..."
      setValue={(newValues) => {
        handleOnChange(newValues);
      }}
      error={errorMessage}
      isDisabled={disabled}
    />
  );
};

export default PowersearchStateValueEditor;
